import * as onboardingApi from "api/endpoints/onboarding";
import * as monitoringApi from "api/endpoints/monitoring";
import * as p2bApi from "api/endpoints/onboarding";
import { createSlice, createSliceSelector } from "../factory";

const name = "approvalPage";

const initialState = {
  approvalDetail: null
};

const slice = createSlice(name, initialState);

export default slice.reducer;

/* Selectors */
const createSelector = createSliceSelector(name);

export const selectApprovalDetail = createSelector((state) => {
  return state.approvalDetail;
});

/* Actions */
const { update } = slice.actions;

export function ApproveDecisioning(request_id, approve_status) {
  return async function (dispatch) {
    onboardingApi
      .approveDecisioning({
        request_id: request_id,
        approve_status: approve_status
      })
      .then((res) => {
        const payload = { approvalDetail: res.details };
        dispatch(update(payload));
      });
  };
}

export function ApproveMonitoring(request_id, approve_status) {
  return async function (dispatch) {
    monitoringApi
      .approveBusiness({
        request_id: request_id,
        approve_status: approve_status
      })
      .then((res) => {
        const payload = { approvalDetail: res.details };
        dispatch(update(payload));
      });
  };
}

export function ApproveP2b(requestId, approvalStatus) {
  return async function (dispatch) {
    p2bApi
      .approveP2b({
        requestId: requestId,
        approvalStatus: approvalStatus
      })
      .then((res) => {
        const payload = { approvalDetail: res.details };
        dispatch(update(payload));
      });
  };
}
